module.exports = __webpack_public_path__ + "img/de-product-classify_img_9.549bc151.jpg";